module.exports = __webpack_public_path__ + "img/newsImg3-15.63413118.png";